import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { QuestionarioQualitativo } from '../../presentation-sheet/models/presentation-sheet';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  private readonly queryEndpoint = `${environment.api}/questionario-qualitativo-query/questionario-qualitativo`;
  private readonly commandEndpoint = `${environment.api}/questionario-qualitativo-command/questionario-qualitativo`;

  constructor(private http: HttpClient) {}

  getByPraticaId(idPratica: string) {
    return this.http.get<QuestionarioQualitativo>(
      `${this.queryEndpoint}/pratica/${idPratica}`
    );
  }

  edit(survey: QuestionarioQualitativo) {
    return this.http.put(`${this.commandEndpoint}/${survey.id}`, survey);
  }
}
